export default __webpack_public_path__ + "static/media/materialthum.39044be3.png";